var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { PROXY_PATH } from '../util/ProxyPath';
// Set default base url for proxied hosts:
axios.defaults.baseURL = PROXY_PATH;
export var BuildAxiosErrorResponse = function (err) {
    var _a;
    return ({
        error: true,
        loading: false,
        errorMessage: ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) || (err === null || err === void 0 ? void 0 : err.message),
    });
};
export var get = function (url, config) { return __awaiter(void 0, void 0, Promise, function () {
    var response, err_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                if (response && response.status >= 200 && response.status < 300) {
                    return [2 /*return*/, {
                            data: response.data,
                            error: false,
                            loading: false,
                        }];
                }
                (_a = window.Sentry) === null || _a === void 0 ? void 0 : _a.captureException(response);
                return [2 /*return*/, {
                        error: true,
                        loading: false,
                    }];
            case 2:
                err_1 = _c.sent();
                (_b = window.Sentry) === null || _b === void 0 ? void 0 : _b.captureException(err_1);
                if (axios.isAxiosError(err_1)) {
                    return [2 /*return*/, BuildAxiosErrorResponse(err_1)];
                }
                return [2 /*return*/, {
                        error: true,
                        loading: false,
                        // prettier-ignore
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        errorMessage: err_1 === null || err_1 === void 0 ? void 0 : err_1.message,
                    }];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var post = function (url, requestBody, config) { return __awaiter(void 0, void 0, Promise, function () {
    var response, err_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post(url, requestBody, config)];
            case 1:
                response = _c.sent();
                if (response && response.status >= 200 && response.status < 300) {
                    return [2 /*return*/, {
                            data: response.data,
                            error: false,
                            loading: false,
                        }];
                }
                (_a = window.Sentry) === null || _a === void 0 ? void 0 : _a.captureException(response);
                return [2 /*return*/, {
                        error: true,
                        loading: false,
                    }];
            case 2:
                err_2 = _c.sent();
                (_b = window.Sentry) === null || _b === void 0 ? void 0 : _b.captureException(err_2);
                if (axios.isAxiosError(err_2)) {
                    return [2 /*return*/, BuildAxiosErrorResponse(err_2)];
                }
                return [2 /*return*/, {
                        error: true,
                        loading: false,
                        // prettier-ignore
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        errorMessage: err_2 === null || err_2 === void 0 ? void 0 : err_2.message,
                    }];
            case 3: return [2 /*return*/];
        }
    });
}); };
